import { App } from 'vue'
import type { SFCWithInstall } from '@utils/types'
import Dropdown from './src/dropdown.vue'

Dropdown.install = (app: App): void => {
  app.component(Dropdown.name, Dropdown)
}

export default Dropdown

declare module 'vue' {
  export interface GlobalComponents {
    PtDropdown: typeof Dropdown;
  }
}
